import { render } from "./p-tree.vue?vue&type=template&id=9015812a&scoped=true"
import script from "./p-tree.vue?vue&type=script&lang=js"
export * from "./p-tree.vue?vue&type=script&lang=js"

import "./p-tree.vue?vue&type=style&index=0&id=9015812a&scoped=true&lang=scss"
import "./p-tree.vue?vue&type=style&index=1&id=9015812a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9015812a"],['__file',"src/components/p-tree.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9015812a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9015812a', __exports__)) {
    api.reload('9015812a', __exports__)
  }
  
  module.hot.accept("./p-tree.vue?vue&type=template&id=9015812a&scoped=true", () => {
    api.rerender('9015812a', render)
  })

}


export default __exports__